import '@shoelace-style/shoelace/dist/components/tag/tag.js';
import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import styles from './tag.styles.scss';

export const PLATFORM_TAG_TAG = 'platform-tag' as const;

/**
 * Stable facade over the third-party tag element — today Shoelace's `sl-tag`, later
 * `wa-tag` — so consumers depend on our element name instead of the vendor's. Put
 * the label in the default slot; set `variant` to color the inner tag's parts.
 *
 * @public
 */
@customElement(PLATFORM_TAG_TAG)
export class PlatformTag extends LitElement {
  static override styles = [styles];

  /** Colors the inner tag's parts; unset renders the neutral default. @public */
  @property({ reflect: true }) variant?: 'new' | 'preview' | 'early-access';

  override render() {
    return html`<sl-tag size="large" pill><slot></slot></sl-tag>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [PLATFORM_TAG_TAG]: PlatformTag;
  }
}
